import { Toaster } from "react-hot-toast";
import { useMediaQuery } from "@/hooks/useMediaQuery";

const MOBILE_QUERY = "(max-width: 640px)";
// Navbar is sticky h-16 (64px); keep desktop toasts clear of its controls.
const DESKTOP_CONTAINER_STYLE = { top: 72 };

const AppToaster = () => {
  const isMobile = useMediaQuery(MOBILE_QUERY);

  return isMobile ? (
    <Toaster position="bottom-center" />
  ) : (
    <Toaster position="top-right" containerStyle={DESKTOP_CONTAINER_STYLE} />
  );
};

export default AppToaster;
